import { TYPE } from './modalLandingCommercial.types';

const initialState = {
  showModalCommercial: false,
  offersSelect: {},
  linkPayment: '',
  paramPaymet: {},
};

export const modalLandingCommercial = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case TYPE.SHOW_MODAL_COMMERCIAL: { //home
      return {
        ...state,
        showModalCommercial: payload
      };
    }
    case TYPE.SET_OFFER_SELECTOR: { //home
      return {
        ...state,
        offersSelect: payload
      };
    }
    case TYPE.SET_PAYMENT_LINK: { //home
      return {
        ...state,
        linkPayment: payload
      };
    }
    case TYPE.SET_PARAM_PAYMENT_IS_ACTIVE: { //home
      return {
        ...state,
        paramPaymet: payload
      };
    }

    default:
      return state;
  }
};